module.exports={
    import: {
        search:'Search',
        sure:'OK',
        downloadResultFile:'Download the result file',
        importPro:'Import product',
        downloadTemplate:'Download template',
        table:{
            index:'Number',
        	fileName:'File name',
        	totalNumber:'Total number',
        	uploadTime:'Upload time',
        	completeTime:'Complete time',
        	result:'Process result',
            uploadUser:'Upload user',
            operation:'Operation'
        },
        hintMsg:{
            success:'Success',
            failed:'Failed',
            queryImportFail:'Failed to Query Import File Information',
            uploadFailed:'Import file processing failed, please re-import'
        },
        upload:{
            format:'Upload files can only be Excel spreadsheets',
            success:'The file was uploaded successfully. Please download the result file later and check the processing result',
            fail:'Importing the product failed',
            incorrectFormat:'The file format is incorrect',
            parseFail:'File parsing failed',
            noPermission:'Failed to import the product,no permission'
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/en/import.js